import { db, requireDb } from '@/lib/firebase';
import { doc, updateDoc, increment } from 'firebase/firestore';
import { isAdmin } from '@/lib/admin';

export async function trackArticleClick(
    articleId: number,
    articleTitle: string,
    categoria: string,
    podkategorija: string,
    podpodkategorija?: string,
    userEmail?: string
) {
    try {
        // Don't track admin users
        if (userEmail && isAdmin(userEmail)) {
            return;
        }

        // Find the article document and increment the clicks field
        const articlesSnapshot = await (async () => {
            const { getDocs, collection, query, where } = await import('firebase/firestore');
            const q = query(collection(requireDb(), 'clanci'), where('id', '==', articleId));
            return getDocs(q);
        })();

        if (articlesSnapshot.docs.length > 0) {
            const articleDoc = articlesSnapshot.docs[0];
            await updateDoc(articleDoc.ref, {
                clicks: increment(1)
            });
            console.log('Article click tracked:', articleId);
        }
    } catch (error) {
        console.error('Error tracking article click:', error);
    }
}
